import './static/fonts/fonts.css'
import smoothscroll from 'smoothscroll-polyfill'

export const onServiceWorkerUpdateReady = () => {
  window.location.reload()
}

export const onClientEntry = () => {
  smoothscroll.polyfill()

  if (
    typeof window !== 'undefined' &&
    window.location.hostname === 'signax.io'
  ) {
    if (!document.getElementById('fb-pixel')) {
      const script = document.createElement('script')
      script.id = 'fb-pixel'
      script.innerHTML = `
         !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '662242762894748');
    fbq('track', 'PageView');
        `
      document.head.appendChild(script)
    }

    if (!document.getElementById('fb-noscript')) {
      const noscript = document.createElement('noscript')
      noscript.id = 'fb-noscript'
      noscript.innerHTML = `
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=662242762894748&ev=PageView&noscript=1" alt=""/>
        `
      document.head.appendChild(noscript)
    }
  }
}

export const onRouteUpdate = () => {
  if (window.dataLayer) {
    const consentGranted = window.dataLayer.some(
      item => item.event === 'consent_granted'
    )

    if (consentGranted) {
      setTimeout(() => {
        window.dataLayer.push({ event: `gatsby-route-change` })
      }, 50)
    }
  }
}
